import { render, staticRenderFns } from "./PoDetails.vue?vue&type=template&id=e27c4db4"
import script from "./PoDetails.vue?vue&type=script&lang=js"
export * from "./PoDetails.vue?vue&type=script&lang=js"
import style0 from "./PoDetails.vue?vue&type=style&index=0&id=e27c4db4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports